const dayjs = require("dayjs");

export const getHeaders = ({ field, order, onEditClick }) => [
    {
      title: "File name",
      dataIndex: "filename",
      key: "filename"
    },
    {
      title: "Date uploaded",
      dataIndex: "started_at",
      key: "started_at",
      sorter: true,
      sortOrder: field === "started_at" ? order : null,
      render: (val) => (val ? dayjs(val)?.format("YYYY-MM-DD HH:mm:ss") : "")
    },
    {
      title: "Import Status",
      dataIndex: "status",
      key: "status",
      sorter: true,
      sortOrder: field === "status" ? order : null,
    },
    {
      title: "Details",
      dataIndex: "details",
      key: "details",
    },
  ]